import { FileMetadataBatchRequestSchema, FileMetadataBatchResponseSchema, PresignedObjectUrlRequestSchema, PresignedObjectUrlResponseSchema, WaferFingerprintWaferPathParamSchema, WaferImageHistoryResponseSchema, } from '../../schemas.js';
/** JSON-only REST contract for presigned URL and metadata routes in `insight-api/src/routes/tenant/file.routes.ts`. */
export const filesContract = {
    getPresignedObjectUrls: {
        method: 'POST',
        path: '/tenant/files/presigned-urls',
        body: PresignedObjectUrlRequestSchema,
        response: PresignedObjectUrlResponseSchema,
        responseStyle: 'unwrap-data',
        timeoutMs: 60000,
        errorMessage: 'Failed to get presigned object URLs',
    },
    getFileMetadata: {
        method: 'POST',
        path: '/tenant/files/metadata',
        body: FileMetadataBatchRequestSchema,
        response: FileMetadataBatchResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get file metadata',
    },
    getWaferImageHistory: {
        method: 'GET',
        path: '/tenant/files/wafers/:waferId/image-history',
        pathParams: WaferFingerprintWaferPathParamSchema,
        response: WaferImageHistoryResponseSchema,
        responseStyle: 'unwrap-data',
        timeoutMs: 60000,
        errorMessage: 'Failed to get wafer image history',
    },
};
//# sourceMappingURL=files.contract.js.map